import { observer } from 'mobx-react';
import { FC } from 'react';
import withTransferForm, { PageIdEnum, TransferFormProps } from '../../../withTransferForm';
import CheckComp from '../components/Check';
import { PARTIAL_ACATS_BASE_PATH } from '../helper';
import { CheckPageFormutil } from '../type';

const Check: FC<TransferFormProps<CheckPageFormutil>> = observer(props => {
    const { onSubmit } = props;
    const handleSubmit = () => {
        onSubmit('../type');
    };

    return <CheckComp onCheckSubmit={handleSubmit} brokerPageId={PageIdEnum.BROKER} {...props} />;
});

export default withTransferForm({
    id: PageIdEnum.CHECK,
    step: 2,
    basePath: PARTIAL_ACATS_BASE_PATH,
    ensure: PageIdEnum.BROKER,
    // 非编辑模式下, broker是前置流程, 除了broker页面之外都要清除
    effectExcept: [PageIdEnum.BROKER]
})(Check);
